import { Injectable } from '@angular/core';
import { HttpClientModule, HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '../config.service';
import { AuthService } from '../auth/auth.service';
import { SucursalModel } from '../../models/sucursal/sucursal.model';

@Injectable({
  providedIn: 'root'
})
export class SucursalService {

  private url = this.configService.config.servidor?.api_cart;

  private baseUrl = this.configService.config.servidor?.api_server;
  //private accessToken: string = this.authService.usuario.token;
  
  constructor(private http: HttpClient, private configService: ConfigService, private authService: AuthService) { }

  getSucursal(){
    // const url = `${this.baseUrl}/Sucursal`;
    // MC CATFER-94 Uso las referencias al archivo resource.json
    const url = this.baseUrl + this.configService.resource.SUCURSAL.VERSION + this.configService.resource.SUCURSAL.PATH_BASE;
    let params = {};
    //{Object.assign(params, {Access_Token: this.accessToken, Plataforma: 2});}
    // console.log( params);
    return this.http.get<SucursalModel>(url, {params: params});
  }

  getSucursalById(id: number) {
    const url = this.baseUrl + this.configService.resource.SUCURSAL.VERSION + this.configService.resource.SUCURSAL.PATH_BASE + `/${id}`;
    // let params = {};
    // {Object.assign(params, {Access_Token: this.accessToken, Plataforma: 2});}
    return this.http.get<SucursalModel>(url);
  }
}
